<template>
  <div class="preview-field" v-if="value" :class="{ 'is-changed': changed }">
    <label class="preview-label">
      {{ label }}
      <span class="changed-badge" v-if="changed">
        <i class="fa fa-pencil"></i>
        Changed
      </span>
    </label>
    <div class="preview-value" :class="{ 'multi-line': multiLine }">
      <span v-if="html && !isTruncated" v-html="value"></span>
      <span v-else-if="html && isTruncated && !expanded">
        <em class="truncation-notice">(Showing plain text preview)</em>
        {{ plainValue.substring(0, maxLength) }}...
      </span>
      <span v-else-if="html && expanded" v-html="value"></span>
      <span v-else>{{ truncatedValue }}</span>
      <button class="btn btn-xs btn-link" v-if="isTruncated" @click="toggleExpand">
        {{ expanded ? 'Show less' : 'Show more' }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true
      },
      value: {
        type: String,
        default: ''
      },
      html: {
        type: Boolean,
        default: false
      },
      multiLine: {
        type: Boolean,
        default: false
      },
      maxLength: {
        type: Number,
        default: 300
      },
      changed: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        expanded: false
      }
    },

    computed: {
      plainValue() {
        if (!this.value) return ''
        if (!this.html) return this.value

        // Strip HTML tags for length calculation
        const div = document.createElement('div')
        div.innerHTML = this.value
        return div.textContent || div.innerText || ''
      },

      isTruncated() {
        return this.plainValue.length > this.maxLength
      },

      truncatedValue() {
        if (!this.value) return ''
        if (this.expanded || !this.isTruncated) return this.value

        // For non-HTML content, simple substring truncation
        return this.value.substring(0, this.maxLength) + '...'
      }
    },

    methods: {
      toggleExpand() {
        this.expanded = !this.expanded
      }
    }
  }
</script>

<style lang="scss" scoped>
  .preview-field {
    margin-bottom: 12px;

    &.is-changed {
      .preview-label {
        color: #8a6d3b;
      }

      .preview-value {
        background-color: #fcf8e3;
        border-color: #faebcc;
      }
    }
  }

  .preview-label {
    font-weight: bold;
    font-size: 12px;
    color: #666;
    margin-bottom: 2px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .changed-badge {
    font-size: 10px;
    font-weight: normal;
    color: #8a6d3b;
    background-color: #fcf8e3;
    padding: 2px 6px;
    border-radius: 3px;
    border: 1px solid #faebcc;
  }

  .preview-value {
    padding: 8px;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 3px;
    font-size: 13px;
    word-wrap: break-word;

    &.multi-line {
      white-space: pre-wrap;
    }
  }

  .truncation-notice {
    display: block;
    font-size: 11px;
    color: #999;
    margin-bottom: 4px;
  }
</style>
